var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatimentGauche1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 255 633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#919191;}.cls-2{fill:#bdbdbd;}.cls-3{fill:#d7d8e6;}.cls-3,.cls-4,.cls-5{stroke:#14151e;stroke-miterlimit:10;stroke-width:2px;}.cls-4{fill:none;}.cls-5{fill:#14151e;}.cls-6{fill:#dbdce3;}.cls-6,.cls-8{opacity:0.54;}.cls-7{fill:#fff;}.cls-8{fill:#b2b4bf;}.cls-9{opacity:0.18;fill:url(#D\xE9grad\xE9_sans_nom_57);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_57",
    x1: 127.5,
    y1: 402,
    x2: 127.5,
    y2: 633.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ec8da",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6391b7"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Finaux") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "batiment_gauche_1",
    "data-name": "batiment gauche 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 121,
    width: 184,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 52,
    width: 161,
    height: 54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35,
    y: 61,
    width: 114,
    height: 66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 110,
    y1: 61,
    x2: 110,
    y2: 127
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71,
    y1: 62.48,
    x2: 71,
    y2: 127
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 106,
    width: 184,
    height: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "184 469.09 15 469.09 15 121 184 121 184 175.43 70 175.43 70 266 184 266 184 272 70 272 70 355 184 355 184 372 70 372 70 452 184 452 184 469.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 161,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 46,
    width: 172,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70,
    y: 175,
    width: 114,
    height: 89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145,
    y1: 175,
    x2: 145,
    y2: 264
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70,
    y: 175,
    width: 114,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 106,
    y1: 177,
    x2: 106,
    y2: 264
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 157,
    y: 175,
    width: 8,
    height: 91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 69,
    y: 253,
    width: 186,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 69,
    y: 219,
    width: 186,
    height: 34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70,
    y: 274,
    width: 24,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 69,
    y: 319,
    width: 26,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70,
    y: 373,
    width: 24,
    height: 78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 69,
    y: 417,
    width: 26,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 402,
    width: 255,
    height: 231.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatimentGauche1);
export default __webpack_public_path__ + "static/media/batiment_gauche_1.ed3ac172712c68738fe77b34acaaf37b.svg";
export { ForwardRef as ReactComponent };